"use client";

import { FoldersEmptyState } from "@zapier/spark-ui";
import styles from "./EmptyState.module.css";

export function EmptyState() {
  return (
    <div className={styles.emptyStateWrapper}>
      <div className={styles.gridWrapper}>
        <FoldersEmptyState />
      </div>
    </div>
  );
}
